var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceUploadedFile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.01 18c4.424 0 8.01-3.582 8.01-8s-3.586-8-8.01-8C5.586 2 2 5.582 2 10s3.586 8 8.01 8z",
  fill: "#46CC88",
  stroke: "#46CC88",
  strokeWidth: 2.221
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m5.92 9.741 3.069 3.065 5.37-5.363",
  stroke: "#fff",
  strokeWidth: 2.221
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceUploadedFile);
export default ForwardRef;